// import config
import axios from "../Config/axios";

export const getAllPages = async () => {
  try {
    let respData = await axios({
      method: "post",
      url: `/settingapi/get-page`,
    });
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.result,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};

export const getSiteSettings = async () => {
  try {
    let respData = await axios({
      method: "post",
      url: `/settingapi/getSiteSetting`,
    });
    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      result: respData.data.result,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};



export const getCMS = async () => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/get-cms`,
    });

    console.log("respDatarespDatarespData", respData);

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      data: respData.data.data,
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.message,
      error: err.response.data.errors,
      data: null,
    };
  }
};


export const getAllFAQ = async (data) => {
  try {
    let respData = await axios({
      method: "post",
      url: `/admin/get-faq`,
      data,
    });

    return {
      status: "success",
      loading: false,
      message: respData.data.message,
      data: respData.data.data,
      count: respData.data.count
    };
  } catch (err) {
    return {
      status: "failed",
      loading: false,
      message: err.response.data.errors,
      error: err.response.data.errors,
    };
  }
};